import { render } from "./TableauLogs.vue?vue&type=template&id=7fb89ebf&scoped=true&ts=true"
import script from "./TableauLogs.vue?vue&type=script&lang=ts"
export * from "./TableauLogs.vue?vue&type=script&lang=ts"

import "./TableauLogs.vue?vue&type=style&index=0&id=7fb89ebf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb89ebf"]])

export default __exports__